module.exports = __webpack_public_path__ + "static/media/interbank.5b6af6ad.svg";